module.exports = __webpack_public_path__ + "img/bamazonM-2.8c9e3dc9.gif";